// Comprehensive Vehicle Makes and Models Dataset
// Updated for 2024-2025 model years

export const VEHICLE_MAKES = [
  'Acura', 'Alfa Romeo', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Buick', 'Cadillac',
  'Chevrolet', 'Chrysler', 'Citroën', 'Dodge', 'Ferrari', 'Fiat', 'Ford', 'Genesis',
  'GMC', 'Honda', 'Hyundai', 'Infiniti', 'Jaguar', 'Jeep', 'Kia', 'Lamborghini',
  'Land Rover', 'Lexus', 'Lincoln', 'Maserati', 'Mazda', 'McLaren', 'Mercedes-Benz',
  'Mini', 'Mitsubishi', 'Nissan', 'Polestar', 'Porsche', 'Ram', 'Rolls-Royce',
  'Subaru', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo'
];

export const VEHICLE_DATA = {
  'Acura': [
    'ILX', 'TLX', 'RLX', 'Integra', 'MDX', 'RDX', 'ZDX', 'NSX'
  ],
  'Alfa Romeo': [
    'Giulia', 'Stelvio', 'Tonale', '4C'
  ],
  'Aston Martin': [
    'DB11', 'DBS', 'Vantage', 'DBX', 'Valkyrie'
  ],
  'Audi': [
    'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8',
    'RS3', 'RS4', 'RS5', 'RS6', 'RS7', 'Q3', 'Q4 e-tron', 'Q5', 'Q7', 'Q8',
    'SQ5', 'SQ7', 'SQ8', 'RSQ8', 'e-tron', 'e-tron GT', 'TT', 'R8'
  ],
  'Bentley': [
    'Continental GT', 'Flying Spur', 'Bentayga', 'Mulsanne'
  ],
  'BMW': [
    '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series',
    'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'Z4', 'i3', 'i4', 'iX', 'iX3'
  ],
  'Buick': [
    'Encore', 'Encore GX', 'Envision', 'Enclave', 'Regal'
  ],
  'Cadillac': [
    'ATS', 'CTS', 'CT4', 'CT5', 'XT4', 'XT5', 'XT6', 'Escalade', 'Lyriq'
  ],
  'Chevrolet': [
    'Spark', 'Sonic', 'Cruze', 'Malibu', 'Impala', 'Camaro', 'Corvette',
    'Trax', 'Equinox', 'Blazer', 'Traverse', 'Tahoe', 'Suburban',
    'Colorado', 'Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD',
    'Bolt EV', 'Bolt EUV'
  ],
  'Chrysler': [
    '300', 'Pacifica', 'Voyager'
  ],
  'Citroën': [
    'C3', 'C4', 'C5 X', 'Berlingo'
  ],
  'Dodge': [
    'Charger', 'Challenger', 'Durango', 'Journey', 'Grand Caravan'
  ],
  'Ferrari': [
    '488', 'F8', 'SF90', 'Roma', 'Portofino', '812', 'LaFerrari'
  ],
  'Fiat': [
    '500', '500X', '500L', 'Tipo', 'Panda'
  ],
  'Ford': [
    'Fiesta', 'Focus', 'Fusion', 'Mustang', 'Taurus',
    'EcoSport', 'Escape', 'Edge', 'Explorer', 'Expedition',
    'Ranger', 'F-150', 'F-250', 'F-350', 'F-450',
    'Mustang Mach-E', 'F-150 Lightning', 'E-Transit',
    'Bronco', 'Bronco Sport'
  ],
  'Genesis': [
    'G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'
  ],
  'GMC': [
    'Terrain', 'Acadia', 'Yukon', 'Yukon XL',
    'Canyon', 'Sierra 1500', 'Sierra 2500HD', 'Sierra 3500HD',
    'Hummer EV'
  ],
  'Honda': [
    'Fit', 'Civic', 'Accord', 'Insight',
    'HR-V', 'CR-V', 'Passport', 'Pilot',
    'Ridgeline', 'Odyssey'
  ],
  'Hyundai': [
    'Accent', 'Elantra', 'Sonata', 'Azera',
    'Venue', 'Kona', 'Tucson', 'Santa Fe', 'Palisade',
    'Veloster', 'Genesis Coupe', 'Ioniq 5', 'Ioniq 6'
  ],
  'Infiniti': [
    'Q50', 'Q60', 'Q70', 'QX30', 'QX50', 'QX60', 'QX80'
  ],
  'Jaguar': [
    'XE', 'XF', 'XJ', 'F-Type', 'E-Pace', 'F-Pace', 'I-Pace'
  ],
  'Jeep': [
    'Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Grand Cherokee L',
    'Wrangler', 'Gladiator', 'Wagoneer', 'Grand Wagoneer'
  ],
  'Kia': [
    'Rio', 'Forte', 'Optima', 'Stinger', 'K5',
    'Soul', 'Seltos', 'Sportage', 'Sorento', 'Telluride',
    'Sedona', 'Carnival', 'Niro', 'EV6'
  ],
  'Lamborghini': [
    'Huracán', 'Aventador', 'Urus'
  ],
  'Land Rover': [
    'Range Rover Evoque', 'Range Rover Velar', 'Range Rover Sport', 'Range Rover',
    'Discovery Sport', 'Discovery', 'Defender'
  ],
  'Lexus': [
    'IS', 'ES', 'GS', 'LS', 'RC', 'LC',
    'UX', 'NX', 'RX', 'GX', 'LX',
    'CT', 'GS F', 'RC F', 'LC F'
  ],
  'Lincoln': [
    'MKZ', 'Continental', 'MKC', 'Corsair', 'MKX', 'Nautilus', 'Aviator', 'Navigator'
  ],
  'Maserati': [
    'Ghibli', 'Quattroporte', 'Levante', 'MC20'
  ],
  'Mazda': [
    'Mazda2', 'Mazda3', 'Mazda6',
    'CX-3', 'CX-30', 'CX-5', 'CX-9', 'CX-50',
    'MX-5 Miata', 'MX-30'
  ],
  'McLaren': [
    '570S', '720S', '765LT', 'Artura', 'GT'
  ],
  'Mercedes-Benz': [
    'A-Class', 'C-Class', 'E-Class', 'S-Class', 'CLA', 'CLS', 'AMG GT',
    'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'G-Class',
    'EQS', 'EQE', 'EQB', 'EQA', 'EQC'
  ],
  'Mini': [
    'Cooper', 'Cooper Countryman', 'Cooper Clubman'
  ],
  'Mitsubishi': [
    'Mirage', 'Lancer', 'Eclipse Cross', 'Outlander', 'Outlander Sport'
  ],
  'Nissan': [
    'Versa', 'Sentra', 'Altima', 'Maxima', '370Z', 'GT-R',
    'Kicks', 'Rogue Sport', 'Rogue', 'Murano', 'Pathfinder', 'Armada',
    'Frontier', 'Titan', 'Leaf', 'Ariya'
  ],
  'Polestar': [
    'Polestar 1', 'Polestar 2', 'Polestar 3'
  ],
  'Porsche': [
    '911', 'Boxster', 'Cayman', 'Panamera',
    'Macan', 'Cayenne',
    'Taycan'
  ],
  'Ram': [
    '1500', '2500', '3500', 'ProMaster'
  ],
  'Rolls-Royce': [
    'Ghost', 'Phantom', 'Wraith', 'Dawn', 'Cullinan'
  ],
  'Subaru': [
    'Impreza', 'Legacy', 'Outback', 'Forester', 'Crosstrek', 'Ascent',
    'WRX', 'BRZ'
  ],
  'Tesla': [
    'Model S', 'Model 3', 'Model X', 'Model Y', 'Cybertruck', 'Roadster'
  ],
  'Toyota': [
    'Yaris', 'Corolla', 'Camry', 'Avalon', 'Prius', 'Prius Prime',
    'C-HR', 'RAV4', 'Venza', 'Highlander', 'Sequoia', '4Runner',
    'Tacoma', 'Tundra', 'Sienna', 'Supra', '86', 'bZ4X'
  ],
  'Volkswagen': [
    'Jetta', 'Passat', 'Arteon', 'Golf', 'GTI', 'Golf R',
    'Taos', 'Tiguan', 'Atlas', 'Atlas Cross Sport',
    'ID.4'
  ],
  'Volvo': [
    'S60', 'S90', 'V60', 'V90',
    'XC40', 'XC60', 'XC90',
    'C40 Recharge', 'XC40 Recharge'
  ]
};

// Vehicle Categories for Depreciation Calculation
export const VEHICLE_CATEGORIES = {
  'Economy': {
    depreciationRate: 0.15, // 15% per year
    makes: ['Chevrolet', 'Ford', 'Honda', 'Toyota', 'Nissan', 'Hyundai', 'Kia', 'Mitsubishi'],
    models: ['Spark', 'Fiesta', 'Fit', 'Yaris', 'Versa', 'Accent', 'Rio', 'Mirage']
  },
  'Midsize': {
    depreciationRate: 0.14, // 14% per year
    makes: ['Honda', 'Toyota', 'Mazda', 'Subaru'],
    models: ['Civic', 'Corolla', 'Accord', 'Camry', 'Mazda3', 'Mazda6', 'Impreza', 'Legacy']
  },
  'SUV': {
    depreciationRate: 0.12, // 12% per year
    makes: ['Ford', 'Chevrolet', 'Toyota', 'Honda', 'Jeep', 'Subaru'],
    models: ['Explorer', 'Tahoe', 'RAV4', 'CR-V', 'Cherokee', 'Forester', 'Highlander']
  },
  'Truck': {
    depreciationRate: 0.10, // 10% per year (holds value well)
    makes: ['Ford', 'Chevrolet', 'Ram', 'GMC', 'Toyota', 'Nissan'],
    models: ['F-150', 'Silverado', '1500', 'Sierra', 'Tacoma', 'Tundra', 'Frontier', 'Titan']
  },
  'Luxury': {
    depreciationRate: 0.18, // 18% per year (higher depreciation)
    makes: ['BMW', 'Mercedes-Benz', 'Audi', 'Lexus', 'Acura', 'Infiniti', 'Cadillac', 'Lincoln'],
    models: []
  },
  'Sports': {
    depreciationRate: 0.16, // 16% per year
    makes: ['Porsche', 'Ferrari', 'Lamborghini', 'McLaren'],
    models: ['Mustang', 'Camaro', 'Corvette', 'Challenger', 'Charger', '911', 'Boxster']
  },
  'Electric': {
    depreciationRate: 0.20, // 20% per year (technology depreciation)
    makes: ['Tesla', 'Polestar'],
    models: ['Model S', 'Model 3', 'Model X', 'Model Y', 'Leaf', 'Bolt', 'i3', 'EQS']
  },
  'Exotic': {
    depreciationRate: 0.12, // 12% per year (collectible value)
    makes: ['Ferrari', 'Lamborghini', 'McLaren', 'Aston Martin', 'Bentley', 'Rolls-Royce'],
    models: []
  }
};

// Function to determine vehicle category
export const getVehicleCategory = (make, model) => {
  // Check luxury makes first
  if (VEHICLE_CATEGORIES.Luxury.makes.includes(make)) {
    return 'Luxury';
  }
  
  // Check exotic makes
  if (VEHICLE_CATEGORIES.Exotic.makes.includes(make)) {
    return 'Exotic';
  }
  
  // Check Tesla and electric
  if (make === 'Tesla' || VEHICLE_CATEGORIES.Electric.models.some(m => model.includes(m))) {
    return 'Electric';
  }
  
  // Check specific model categories
  if (VEHICLE_CATEGORIES.Sports.models.some(m => model.includes(m))) {
    return 'Sports';
  }
  
  if (VEHICLE_CATEGORIES.Truck.models.some(m => model.includes(m))) {
    return 'Truck';
  }
  
  if (VEHICLE_CATEGORIES.SUV.models.some(m => model.includes(m))) {
    return 'SUV';
  }
  
  if (VEHICLE_CATEGORIES.Economy.models.some(m => model.includes(m))) {
    return 'Economy';
  }
  
  // Default to midsize for most cars
  return 'Midsize';
};

// Calculate estimated current value based on depreciation
export const calculateEstimatedValue = (originalPrice, make, model, year, mileage = 0, condition = 'good') => {
  const currentYear = new Date().getFullYear();
  const age = Math.max(0, currentYear - year);
  
  if (age === 0) return originalPrice; // New vehicle
  
  const category = getVehicleCategory(make, model);
  const baseDepreciationRate = VEHICLE_CATEGORIES[category].depreciationRate;
  
  // Apply compound depreciation
  let estimatedValue = originalPrice;
  for (let i = 0; i < age; i++) {
    estimatedValue *= (1 - baseDepreciationRate);
  }
  
  // Adjust for mileage (typical: 12,000 miles/year)
  const expectedMileage = age * 12000;
  const mileageAdjustment = Math.max(0.7, 1 - ((mileage - expectedMileage) / 100000)); // -30% max for high mileage
  estimatedValue *= mileageAdjustment;
  
  // Adjust for condition
  const conditionMultipliers = {
    excellent: 1.1,
    good: 1.0,
    fair: 0.85,
    poor: 0.65
  };
  estimatedValue *= conditionMultipliers[condition] || 1.0;
  
  return Math.round(estimatedValue);
};

// Get model years (typically last 35 years)
export const getModelYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear + 1; year >= currentYear - 34; year--) {
    years.push(year);
  }
  return years;
};
